/**
 * HomeLayout - Minimal layout for the public homepage
 * Shows only ARKX logo and Join Waitlist button
 */
import { Link, Outlet } from 'react-router-dom';
import { getAppUrls } from '../../utils/domainDetection';

export default function HomeLayout() {
  const shopUrl = getAppUrls().shop;

  return (
    <div className="min-h-screen bg-white">
      {/* Minimal Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <img
                src="/arkx_black.png"
                alt="ARKX"
                className="h-6 sm:h-7 w-auto"
              />
            </Link>

            {/* Right side: Sell on ARKX link + Shop Now button */}
            <div className="flex items-center gap-6">
              <Link
                to="/logistics"
                className="hidden sm:block text-sm font-medium text-gray-700 hover:text-black transition-colors"
              >
                Logistics
              </Link>
              <Link
                to="/sell"
                className="hidden sm:block text-sm font-medium text-gray-700 hover:text-black transition-colors"
              >
                Sell on ARKX
              </Link>
              <a
                href={shopUrl}
                className="px-6 py-2.5 bg-black text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-colors inline-block"
              >
                Shop Now
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content with top padding for fixed header */}
      <main className="pt-16">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-black text-white py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
            {/* Logo & Tagline */}
            <div>
              <span className="text-2xl font-bold tracking-tight">
                ARK<span className="font-light">X</span>
              </span>
              <p className="text-gray-400 text-sm mt-2">Shop LA. Delivered in Hours.</p>
            </div>

            {/* Links */}
            <div className="flex flex-wrap gap-6 md:gap-8 text-sm">
              <Link to="/logistics" className="text-gray-400 hover:text-white transition-colors">
                Logistics
              </Link>
              <Link to="/sell" className="text-gray-400 hover:text-white transition-colors">
                Sell on ARKX
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                Privacy
              </Link>
              <Link to="/return-policy" className="text-gray-400 hover:text-white transition-colors">
                Returns
              </Link>
              <a href="mailto:support@arkxla.com" className="text-gray-400 hover:text-white transition-colors">
                Contact
              </a>
              <a href="https://portal.arkxla.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                Brand Portal
              </a>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-500 text-xs">
            © {new Date().getFullYear()} ARKX. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
